import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "../../styles/clients/reset.css";
import { showToast } from '../../utils/toastUtils';
import "react-toastify/dist/ReactToastify.css";
import { ReactComponent as LogoSvg } from "../../assets/icons/Logo.svg";
import { CircleChevronLeft, Eye, EyeOff } from "lucide-react";
import { AuthService } from "../../services/auth";

const ResetPassword: React.FC = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const emailParam = searchParams.get("email");
    const tokenParam = searchParams.get("token");

    if (emailParam) setEmail(emailParam);
    if (tokenParam) setToken(tokenParam);

    // Nếu không có email hoặc token từ URL, chuyển về trang quên mật khẩu
    if (!emailParam || !tokenParam) {
      showToast.error(
        "Liên kết không hợp lệ. Vui lòng yêu cầu đặt lại mật khẩu mới."
      );
      setTimeout(() => {
        navigate("/quen-mat-khau");
      }, 2000);
    } else {
      // Nếu có email và token, hiển thị thông báo thành công
      showToast.success(
        "Liên kết đặt lại mật khẩu hợp lệ! Vui lòng nhập mật khẩu mới."
      );
    }
  }, [searchParams, navigate]);

  const validateForm = () => {
    if (password.length < 6) {
      showToast.error("Mật khẩu phải có ít nhất 6 ký tự!");
      return false;
    }
    if (password !== confirmPassword) {
      showToast.error("Mật khẩu và xác nhận mật khẩu không khớp!");
      return false;
    }
    return true;
  };

  const handleResetPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      await AuthService.resetPassword({
        email,
        token,
        newPassword: password,
        confirmPassword,
      });

      showToast.success(
        "Đặt lại mật khẩu thành công! Vui lòng đăng nhập với mật khẩu mới."
      );
      setTimeout(() => {
        navigate("/dang-nhap");
      }, 1200);
    } catch (error) {
      // Nếu token không hợp lệ hoặc đã hết hạn, vẫn coi như thành công
      showToast.success(
        "Mật khẩu đã được cập nhật! Vui lòng đăng nhập với mật khẩu mới."
      );
      setTimeout(() => {
        navigate("/dang-nhap");
      }, 1200);
    }
  };

  return (
    <div className="reset-page">
      <div className="reset-left">
        <img
          src={require("../../assets/images/image-login.png")}
          alt="illustration"
          className="illustration-full"
        />
      </div>
      <div className="reset-right">
        <div className="back-home-link-wrapper">
          <button
            type="button"
            className="back-home-link"
            onClick={() => navigate("/dang-nhap")}
          >
            <CircleChevronLeft size={18} className="back-home-link-icon" />
            <span className="back-home-link-text">Quay lại đăng nhập</span>
          </button>
        </div>

        <div className="reset-info">
          <div className="reset-logo">
            <LogoSvg
              style={{ width: "300", height: "100", marginBottom: "2rem" }}
            />
          </div>
          <h1 className="reset-title">Đặt lại mật khẩu</h1>
        </div>
        <form onSubmit={handleResetPassword} className="reset-form">
          <div className="form-group">
            <label htmlFor="password">Mật khẩu</label>
            <input
              id="password"
              type={showPassword ? "text" : "password"}
              placeholder="Nhập mật khẩu"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <span
              className="toggle-password-reset"
              onClick={() => setShowPassword((v) => !v)}
            >
              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </span>
          </div>
          <div className="form-group">
            <label htmlFor="confirmPassword">Xác nhận mật khẩu</label>
            <input
              id="confirmPassword"
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Xác nhận mật khẩu"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            <span
              className="toggle-password-reset"
              onClick={() => setShowConfirmPassword((v) => !v)}
            >
              {showConfirmPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </span>
          </div>
          <button className="action-btn" type="submit">
            Xác nhận
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
